import {
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  InputGroup,
  Placeholder,
  Row,
  Table,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import TributacaoCfopCode from "./TributacaoCfop.Code";
import { useEffect, useState } from "react";
import { IRoute } from "src/interfaces/IRoute";
import { useNavigate } from "react-router-dom";

const TributacaoCfopView = () => {
  const [menuItens, setMenuItens] = useState<IRoute[]>([]);
  const navigate = useNavigate();
  const { register, errors, handleSubmit, onSubmit, loading, data } =
    TributacaoCfopCode();

  useEffect(() => {
    setMenuItens([
      {
        name: "Novo Cfop...",
        route: "/fiscal/tributacao/cfop/cadastro",
      },
    ]);
  }, []);

  const handleClickNavigate = (route: string) => () => {
    navigate(route);
  };

  const handleClickAlterar = (id: number) => () => {
    navigate(`/fiscal/tributacao/cfop/cadastro?id=${id}`);
  };

  return (
    <Container>
      <HeadPage headText="Tributação Cfop">
        {menuItens !== undefined &&
          menuItens.map((item) => (
            <Dropdown.Item
              key={item.name}
              onClick={handleClickNavigate(item.route)}
            >
              {item.name}
            </Dropdown.Item>
          ))}
      </HeadPage>
      <Row>
        <Col>
          <Form noValidate onSubmit={handleSubmit(onSubmit)}>
            <InputGroup hasValidation>
              <FloatingLabel controlId="pesquisar" label="Pesquisar">
                <Form.Control
                  type="text"
                  placeholder="Pesquisar"
                  isInvalid={!!errors.nome?.message?.toString()}
                  {...register("nome")}
                />
                {errors.nome?.message?.toString() && (
                  <Form.Control.Feedback type="invalid">
                    {errors.nome?.message?.toString()}
                  </Form.Control.Feedback>
                )}
              </FloatingLabel>
            </InputGroup>
          </Form>
        </Col>
      </Row>
      <Row>
        {!loading ? (
          <Col>
            {data && data.length > 0 ? (
              <Table responsive striped hover>
                <thead>
                  <tr>
                    <th className="col-3">CFOP</th>
                    <th className="d-none d-md-table-cell col-5">
                      Tipo Parametro
                    </th>
                    <th className="d-none d-sm-table-cell col-2">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => (
                    <tr
                      key={item.id}
                      onClick={handleClickAlterar(item.id)}
                      style={{ cursor: "pointer" }}
                    >
                      <td className="col-3">{item.cfop}</td>
                      <td className="d-none d-md-table-cell col-5">
                        {item.tipoParametro} - {item.tipoParametroDescricao}
                      </td>
                      <td className="d-none d-sm-table-cell col-2">
                        {item.parametroValor}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <Form.Text>Sem Dados</Form.Text>
            )}
          </Col>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Row>
    </Container>
  );
};
export default TributacaoCfopView;
